export default __webpack_public_path__ + "static/media/boxicons.c6d7d035.woff2";